export enum SyncStatusEnum {
  NotSynced,
  Synced,
  Syncing,
  Error
}
